<footer class="footer">
	<div class="container-fluid">
		<div class="row">
			<div class="col-sm-6">
				{{year}} © Revealense. Illuminate the hidden
				</div>
			<div class="col-sm-6">
				<div class="text-sm-end d-none d-sm-block">
					<a href="https://lordicon.com/">Animated icons by Lordicon.com</a>
				</div>
			</div>
		</div>
	</div>
</footer>